<template>
	<div>
		<div class="center" v-if="this.userModel && this.isLoggedIn" style="max-height:calc(80vh - 300px);">


			<div v-if="this.isPopover" class="flexcenter " style="" @click="this.$emit('hideAllSubmenu')">
				<div class="flexcenter link" style="background:var(--bg-message);padding:5px;border-radius: 5px;">
					<Circle fileName="w3_chevron_left_white" color="" size="15px" padding="25%" style="margin-right:5px;" />
					<b style="color:white;margin-right:5px;" class="font-small">Stäng och återgå till föregående sida</b>
				</div>

			</div>
			<div style="background:var(--grey-bg);min-height:300px;margin-top:10px;">
				<SlideList :slideList="slideList" style="margin-top:0px;" />
			</div>

			<div class="center-padding" style="padding-bottom:10px;">
				<h3 style="margin-top:10px;">Rekomenderade produkter</h3>
				<div class="flexcenter"
					style="background:white;justify-content:stretch;align-items: start;max-height:500px;overflow:scroll;scroll-snap-type: x mandatory;">

					<ProductCell class="product product-cell" v-for="(productId, index) in this.productIdList" :key="productId"
						:rowIndex="index" :productId="productId" :parentTitle="this.title"
						@showProductDetails="((product) => this.showProductDetails(product))" />

				</div>

				<h3 style="margin-bottom:10px;margin-top:10px;">Nyheter</h3>
				<div v-for="news in this.userModel.newsList" :key="news.id"
					style="background:var(--grey-4);padding:10px;border-radius: 5px;margin-bottom:10px;">
					<div class="flexcenter">
						<h3 style="flex-grow:1;">{{ news.title }}</h3>
						<div :title="news.dateTime">{{ this.timeSince(news.dateTime) }}</div>
					</div>
					<p v-html="news.html"></p>
				</div>
			</div>


		</div>
		<LoginRequired v-if="!this.isLoggedIn" @showSubMenuLogin="(() => { this.$emit('showSubMenuLogin') })" />
	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";
import { userMixin } from "@/mixins/userMixin.js";
import LoginRequired from "./LoginRequired.vue";
import { routerMixin } from "@/mixins/routerMixin.js";
import { formatMixin } from "@/mixins/formatMixin.js";
import ProductCell from "../../views/product/ProductCell.vue";
import { USER_STORE_COMMIT, USER_STORE_GETTER } from "../../store/user-store";
import SlideList from "../slide/SlideList.vue";
import { STORE_GETTER } from "../../store/store";

export default {
	name: "ResellerNews",
	components: { LoginRequired, ProductCell, SlideList },
	mixins: [userMixin, routerMixin, formatMixin],
	props: {
		isPopover: {
			value: Boolean,
			default: false
		}
	},
	data() {
		return {

		};
	},
	computed: {


		title(){
			return "resellerNews";
		},
		newsList(){
			return this.userModel?.newsList();
		},

		productIdList(){
			return this.userModel?.productIdList?.start?.filter(productId => productId != null)
		},

		slideList() {


			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			var list = baseModel?.slideList?.filter(slide => slide !== null && slide.type.includes("NYHETER"));

			if (!list) {
				return [];
			}

			return list;
		}, 






	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		showProductDetails(product) {

			if (this.isPopover){
				
				this.$store.commit(USER_STORE_COMMIT.SET_TEMP_PRODUCT, product);

				this.$router.push({ name: "ResellerNews" })
				this.$emit('hideAllSubmenu');
				
				//this.$router.push('/user/reseller-news?456');

			}else{
				this.routerShowProductDetails(product)
			}

			
		},


	},
	created() {

		// FP: Så att vi kan få rätt sida på "tillbaka-knappen"
		const product = this.$store.getters[USER_STORE_GETTER.GET_TEMP_PRODUCT];
		if (product){
			this.$store.commit(USER_STORE_COMMIT.SET_TEMP_PRODUCT, null);
			this.routerShowProductDetails(product);
			

		}
		
	}
};
</script>

<style scoped>

div.product.product-cell{
	min-width: 300px;
		max-width: 300px;
		border: 1px solid white;
		height: auto;
		scroll-snap-align: center;
}
</style>